import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { OrganicMobCorpse } from "./organicMobCorpse";

export class AmoebaCorpse extends OrganicMobCorpse {
	static key = "AmoebaCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): AmoebaCorpse {
		const c = new AmoebaCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
